import revive_payload_client_4sVQNw7RlN from "/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/src/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_immediate_client_xfI97IMoyr from "/src/node_modules/nuxt/dist/app/plugins/chunk-reload-immediate.client.js";
import plugin_vue3_A0OWXRrUgq from "/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_PSbK9A48ZQ from "/src/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import i18n_Ug908EZNww from "/src/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_tMGwffvjBc from "/src/node_modules/@formkit/auto-animate/nuxt/runtime/plugin.mjs";
import plugin_ghbUAjaD3n from "/src/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_Jozdw60ZsE from "/src/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import i18n_yfWm7jX06p from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import _00_suppress_vue_warnings_VCufr9iADx from "/src/plugins/00.suppress-vue-warnings.ts";
import _01_refresh_access_token_LYgKNBv9Ew from "/src/plugins/01.refresh-access-token.ts";
import _02_auth_kllCetJ9Sb from "/src/plugins/02.auth.ts";
import _03_consent_2UySPZP2NX from "/src/plugins/03.consent.ts";
import _04_monetate_Q2hl0QfcoF from "/src/plugins/04.monetate.ts";
import _05_gtm_client_6DtW7C6cJm from "/src/plugins/05.gtm.client.ts";
import bazaarvoice_client_vOu8OkNkLp from "/src/plugins/bazaarvoice.client.ts";
import customErrorService_vforEhWvdy from "/src/plugins/customErrorService.ts";
import datadog_rum_client_enPp5k569L from "/src/plugins/datadog-rum.client.js";
import exponea_client_vjTtJPUBrA from "/src/plugins/exponea.client.ts";
import feature_init_hoCxjMpcGR from "/src/plugins/feature-init.ts";
import lru_cache_client_qnDM2Zai7C from "/src/plugins/lru-cache.client.ts";
import scrollTracking_client_qAPH4OjGmt from "/src/plugins/scrollTracking.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_immediate_client_xfI97IMoyr,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_PSbK9A48ZQ,
  i18n_Ug908EZNww,
  plugin_tMGwffvjBc,
  plugin_ghbUAjaD3n,
  plugin_Jozdw60ZsE,
  i18n_yfWm7jX06p,
  _00_suppress_vue_warnings_VCufr9iADx,
  _01_refresh_access_token_LYgKNBv9Ew,
  _02_auth_kllCetJ9Sb,
  _03_consent_2UySPZP2NX,
  _04_monetate_Q2hl0QfcoF,
  _05_gtm_client_6DtW7C6cJm,
  bazaarvoice_client_vOu8OkNkLp,
  customErrorService_vforEhWvdy,
  datadog_rum_client_enPp5k569L,
  exponea_client_vjTtJPUBrA,
  feature_init_hoCxjMpcGR,
  lru_cache_client_qnDM2Zai7C,
  scrollTracking_client_qAPH4OjGmt
]